export default __webpack_public_path__ + "static/bentoSectionBg4-9eb9499d3630373b1b523a3cd4f84eb1.webp";